import $ from 'jquery';

import { showError, hideError } from '../../general/Error';
import { asyncValidateAll } from '../CheckoutUtil';

// Setup default errors.
const ERRORS = {
	'INVALID_BIRTHMONTH': {
		'geburtsmonat': [],
	},
	'INVALID_BIRTHDAY': {
		'geburtstag': [],
	},
	'INVALID_BIRTHDATE': {
		'geburtstag': [],
		'geburtsmonat': [],
	},
	'INVALID_PLUSCARD': {
		'pluscard': {
			'element': '#plc_msg1'
		},
	},
	'REQUIRED_PLUSCARD': {
		'pluscard': {
			'element': '#plc_msg1'
		},
	}
}

class VerifyPluscardClass {

	isValid = false;

	cancelController = null;

	constructor( sectionEl ) {
		this.sectionEl = sectionEl;

		// Change Handler
		this.sectionEl.querySelectorAll( 'input, select, textarea' ).forEach( inputEl => {
			inputEl.addEventListener( 'change', () => this.maybeVerify() );
		} );
	}

	setState( state ) {
		const wrapperEls = this.sectionEl.querySelectorAll( '.input_wrapper--has_stateindicator' );
		wrapperEls.forEach( wrapperEl => {
			wrapperEl.dataset.state = state;
		} );
	}

	verifyTimeout = null;

	maybeVerify() {
		clearTimeout( this.verifyTimeout );
		this.verifyTimeout = setTimeout( () => {
			const sectionEl = this.sectionEl.querySelector( '#form_section_register_pluscard_current' );
			if ( sectionEl ) {
				const inputEls = Array.from( sectionEl.querySelectorAll( 'input, select, textarea' ) );
				// If each Input El has a valid value, we trigger the verifícation.
				if ( inputEls.every( inputEl => inputEl.value && inputEl.checkValidity() ) ) {
					this.verify( true );
				}
			}
		}, 100 );
	}

	 postVerifyRequest() {
		return new Promise( ( resolve, reject ) => {

			const numberEl = this.sectionEl.querySelector( '#register_pluscard_number' );
			const monthEl = this.sectionEl.querySelector( '#register_pluscard_month' );
			const dayEl = this.sectionEl.querySelector( '#register_pluscard_day' );

			// Values.
			const plc_number  = numberEl?.value ?? '';
			const birthmonth = monthEl?.value ?? '';
			const birthday   = dayEl?.value ?? '';

			// Check if input field have valid values - if empty we don't have to check ajax.
			const checks = [
				[ plc_number, ERRORS.REQUIRED_PLUSCARD ],
				[ birthmonth, ERRORS.INVALID_BIRTHMONTH ],
				[ birthday, ERRORS.INVALID_BIRTHDAY ],
			];

			// Check all values, and reject, if failed.
			for ( const [ value, errorType ] of checks ) {
				if ( value === '' ) {
					// Reject with error.
					reject( { 'errors': errorType } );
					return false;
				}
			}

			// Ensure only the last call gets through.
			if ( this.cancelController ) {
				this.cancelController.abort();
				this.cancelController = null;
			}

			// Verify async.
			this.cancelController = new AbortController();
			return fetch( '/index.php?cl=user&fnc=verifyCustomerCard', {
				method: 'POST',
				body: new URLSearchParams( {
					'number': plc_number,
					'birthday': String( birthday ).padStart( 2, '0' ),
					'birthmonth': String( birthmonth ).padStart( 2, '0' ),
				} ),
				signal: this.cancelController.signal
			} ).then( async res => {
				if ( res.ok ) {
					return await res.text();
				}

				return await Promise.reject( res.text() );
			} ).then( res => {
				try {
					return JSON.parse( res );
				} catch ( parseErr ) { // eslint-disable-line no-unused-vars
					return res;
				}
			} ).then( response => {
				if ( 'object' === typeof response ) {
					// New Implementation.
					if ( 'activeCardType' in response && response.activeCardType ) {
						resolve( response );
					} else if ( 'errors' in response && response.errors ) {
						reject( response );
					} else {
						reject( { 'errors': ERRORS.INVALID_PLUSCARD } );
					}
				} else {
					// Old Implementation.
					if ( '1' === response ) {
						resolve( true );
					} else if ( '-1' === response ) {
						// Mark Pluscard number faulty.
						reject( { 'errors': ERRORS.INVALID_PLUSCARD } );
					} else {
						// Mark Birthday faulty.
						reject( { 'errors': ERRORS.INVALID_BIRTHDATE } );
					}
				}
			} )
				.catch( ( err ) => {
					console.error( err ); // eslint-disable-line no-console
					reject()
				} )
				.finally( () => {
					this.cancelController = null;
				} );

		} )
	}

	verify( force = false ) {
		const sectionEl = this.sectionEl;

		// No Section - Nothing to check.
		// Skip this step and return true.
		if ( ! sectionEl ) {
			return true;
		}

		// Skip check, if we validated as valid previously.
		if ( this.isValid && ! force ) {
			return true;
		}

		// Should we check Pluscard at all? - if not proceed.
		const checkPluscardNumberEl = this.sectionEl.querySelector( '#register_pluscard_current' );
		if ( ! ( checkPluscardNumberEl && checkPluscardNumberEl.checked ) ) {
			return true;
		}

		// Set valid to false before we check.
		this.isValid = false;

		// Show loading indicator.
		this.setState( 'loading' );

		this.postVerifyRequest()
			.then( ( response ) => {
			// Remove Errors and return success.
				const inputEls = this.sectionEl.querySelectorAll( 'input, select, textarea' );
				inputEls.forEach( inputEl => hideError( inputEl ) );

				// Verification succeeded.
				this.isValid = true;
				this.setState( 'success' );

				if ( 'object' === typeof response ) {
					const shouldBeLock = response['activeCardType'] === '3';

					const prefills = {
						'salutation': '#_salutation',
						'firstname': '#register_invoice_2_firstname',
						'lastname': '#register_invoice_2_lastname',
						'street': '#register_invoice_2_street_and_number',
						'zipcode': '#register_invoice_2_postal',
						'ort': '#register_invoice_2_city',
						'country_id': '#countryTxt-size',
					}

					for ( const [ field, selector] of Object.entries( prefills )  ) {
						const inputEl = document.querySelector( selector );
						if ( ! inputEl ) {
							continue;
						}

						const shouldBeReadonly = shouldBeLock || field === 'firstname' || field === 'salutation';
						if ( inputEl.matches( '.en_switch' ) ) {
							// Get matching label.
							const labelEl = Array.from( inputEl.querySelectorAll( '.label' ) ).find( ( searchEl ) => searchEl.innerText === response[ field ] );

							// Sanity check.
							if ( labelEl ) {

								// Set the Correct radio true.
								labelEl.click();

								// Set other fields disabled.
								inputEl.querySelectorAll( 'input[type=radio]' ).forEach( radioEl => {
									radioEl.disabled = ! radioEl.checked;
									radioEl.classList.toggle( 'input--plc-temp-disabled', ! radioEl.checked );
								} );
							} else {

								// Make all the fields free again.
								inputEl.querySelectorAll( 'input[type=radio]' ).forEach( radioEl => {
									radioEl.disabled = false;
									radioEl.classList.toggle( 'input--plc-temp-disabled', false );
								} );
							}
						} else if ( inputEl.matches( 'select' ) || inputEl.matches( '.en_select' ) ) {
							// Handle select elements.
							const selectEl = inputEl.matches( 'select' ) ? inputEl : inputEl.querySelector( 'select' );
							const selectValue = response[ field ];

							if ( selectValue !== undefined ) {
								selectEl.value = selectValue;
								if ( shouldBeReadonly && selectValue.length > 0 ) {
									selectEl.disabled = true;
									selectEl.classList.add( 'input--plc-temp-disabled' );
								} else {
									selectEl.disabled = false;
									selectEl.classList.remove( 'input--plc-temp-disabled' );
								}
							}
						} else {
							// Set Fields readonly.
							inputEl.value = response[ field ] ?? '';
							if ( shouldBeReadonly && response[ field ].length > 0 ) {
								inputEl.readOnly = true;
								inputEl.classList.add( 'input--plc-temp-readonly' );
							}

							inputEl.dispatchEvent( new CustomEvent( 'validate_input.acl', { bubbles: true } ) );
						}
					}
				}

			} ).catch( errorObj => {

				if ( 'object' === typeof errorObj ) {

					if ( 'errors' in errorObj ) {
						for ( const field in errorObj.errors ) {
							const error = errorObj.errors[ field ];
							let message = null;

							if ( Array.isArray( error ) ) {
								message = error[0] || null;
							} else if ( 'object' === typeof error && 'element' in error ) {
								message = $( error.element ).text();
							}

							switch ( field ) {
								case 'geburtstag':
								case 'geburtsmonat':
									this.sectionEl.querySelectorAll( '#register_pluscard_birthday_notification :where(input, select, textarea)' ).forEach( ( inputEl ) => this.showError( inputEl, message ) );
									break;
								default:
									this.sectionEl.querySelectorAll( '#register_pluscard_number_notification :where(input, select, textarea)' ).forEach( ( inputEl ) => this.showError( inputEl, message ) );
									break;
							}
						}
					} else if ( 'message' in errorObj ) {
					// Show message for pluscard field.
						this.sectionEl.querySelectorAll( '#register_pluscard_number_notification :where(input, select, textarea)' ).forEach( ( inputEl ) => this.showError( inputEl, errorObj.message ) );
					}
				}

				// Re-enable temporarily deactivated fields, so the form stays useable, if we added a valid plc, and then removed it.
				document.querySelectorAll( '.input--plc-temp-disabled' ).forEach( ( inputEl ) => {
					inputEl.disabled = false;
					inputEl.classList.remove( 'input--plc-temp-disabled' );
				} );
				document.querySelectorAll( '.input--plc-temp-readonly' ).forEach( ( inputEl ) => {
					inputEl.readOnly = false;
					inputEl.classList.remove( 'input--plc-temp-readonly' );
				} )

				// Set State to error.
				this.isValid = false;
				this.setState( 'error' );

				// Verification failed.
				return false;
			} );
	}

	showError( inputEl, message, state = 'error' ) {
		if ( inputEl.dataset.displayValidation ) {
			showError( inputEl, message, state );
		}
	}

	static getInstance = ( sectionEl ) => {
		sectionEl.ACL_VERIFY_PLUSCARD ??= new VerifyPluscardClass( sectionEl );
		return sectionEl.ACL_VERIFY_PLUSCARD;
	}

	static verifyPluscardNumber = ( sectionEls, force = false ) => {

		const promises = Array.from( $( sectionEls ) ).map( sectionEl => {
			return VerifyPluscardClass.getInstance( sectionEl ).verify( force );
		} );

		return asyncValidateAll( promises );
	};
}


const initVerifyPluscard = ( scopeEl = document ) => {
	scopeEl.querySelectorAll( '.verifypluscard_section' ).forEach( sectionEl => {
		VerifyPluscardClass.getInstance( sectionEl );
	} )
};

// Init.
document.addEventListener( 'init_forms.acl', () => initVerifyPluscard() );

// Expose.
const verifyPluscardNumber = VerifyPluscardClass.verifyPluscardNumber;
window.verifyPluscard = verifyPluscardNumber;

// Export.
export {
	verifyPluscardNumber as default,
	initVerifyPluscard,
	VerifyPluscardClass
};
